import { z } from "zod";

// SchedulingExceptionCreateInput (api/contracts/parts/60-portal-scheduling.yaml):
// onDate y reason obligatorios; slotTime vacío = día completo. El error de
// campo (formato/obligatoriedad) se valida acá; el rechazo de negocio
// (QUOTA_HAS_APPOINTMENTS) es de servicio y va al toast (P8A-01 §4.1/§5), no
// a este esquema.
export const exceptionFormSchema = z.object({
  onDate: z.string().min(1, "La fecha es obligatoria"),
  slotTime: z.string(),
  reason: z.string().trim().min(1, "El motivo es obligatorio"),
});

export type ExceptionFormValues = z.infer<typeof exceptionFormSchema>;
